
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"45","height":"31","rx":"5.5","fill":"#fff","stroke":"#000"}}),_c('path',{attrs:{"d":"M12.588 10.646c.394-.497.661-1.164.59-1.846-.576.029-1.28.384-1.687.881-.366.426-.69 1.121-.605 1.774.647.057 1.294-.326 1.702-.809zM13.171 11.583c-.94-.057-1.739.538-2.188.538-.449 0-1.136-.51-1.88-.496-.967.014-1.865.566-2.356 1.444-1.01 1.756-.266 4.36.716 5.79.477.708 1.051 1.487 1.809 1.459.715-.028.996-.468 1.866-.468.869 0 1.122.468 1.88.454.785-.014 1.276-.708 1.753-1.416.547-.807.77-1.586.785-1.628-.014-.014-1.515-.595-1.529-2.336-.014-1.458 1.178-2.152 1.235-2.195-.674-1.004-1.726-1.118-2.09-1.146zM21.355 9.61c2.043 0 3.466 1.42 3.466 3.488 0 2.076-1.452 3.503-3.517 3.503h-2.262v3.629h-1.634V9.61h3.947zm-2.313 5.608h1.876c1.422 0 2.232-.773 2.232-2.113 0-1.339-.81-2.104-2.225-2.104h-1.883v4.217zM25.248 18.03c0-1.355 1.029-2.187 2.853-2.29l2.101-.125v-.596c0-.861-.576-1.376-1.54-1.376-.911 0-1.48.441-1.619 1.133h-1.488c.087-1.398 1.269-2.429 3.166-2.429 1.86 0 3.05.994 3.05 2.547v5.336h-1.51v-1.274h-.037c-.445.862-1.415 1.406-2.422 1.406-1.503 0-2.554-.942-2.554-2.333zm4.954-.7v-.61l-1.89.117c-.94.066-1.473.486-1.473 1.148 0 .677.554 1.119 1.4 1.119 1.102 0 1.963-.766 1.963-1.774zM33.197 23.078V21.79c.116.03.379.03.51.03.73 0 1.124-.31 1.365-1.105 0-.014.139-.47.139-.478l-2.773-7.75h1.707l1.941 6.3h.03l1.94-6.3h1.664l-2.875 8.147c-.657 1.877-1.416 2.48-3.006 2.48-.132 0-.526-.014-.642-.036z","fill":"#000"}})])
          )
        }
      }
    